import store from '~/javascripts/store.js';
import t from '~/javascripts/utils/translation';
import { observer } from 'mobx-react';
import { useEffect, useRef } from 'react';

const DonateFormIhoDelivery = observer(() => {
  const {
    deliveryNotification,
    recipientEmail,
    recipientFullName,
    sendOn,
    sendTo,
    sendType,
    type,
  } = store.iho.honoreeDraft;
  const datepickerRef = useRef(null);

  useEffect(() => {
    initDatePicker();
  }, [store.iho.honoreeDraft.sendType]);

  const preventModalFromClosingIfDatePickerIsOpen = (event) => {
    if (
      $('.hasDatepicker').length &&
      $('.hasDatepicker').datepicker('widget').is(':visible')
    ) {
      event.stopPropagation();
    }
  };

  const initDatePicker = () => {
    if (store.iho.honoreeDraft.sendType === 'schedule') {
      import('jquery-ui/ui/widgets/datepicker.js').then(() => {
        $(datepickerRef.current).datepicker({
          dayNamesMin: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
          minDate: new Date(),
          dateFormat: t('views.donate_form.iho.date_picker_format'),
          beforeShow: () => {
            $('.modal-open').on(
              'click',
              preventModalFromClosingIfDatePickerIsOpen
            );
          },
          onSelect: (value) => {
            store.iho.updateHonoreeDraft({
              target: {
                name: 'sendOn',
                value: value,
              },
            });
          },
        });
      });
    }
  };

  return (
    <>
      <div className='input-wrapper recipient-select'>
        <div className='custom-check'>
          <input
            checked={sendTo === 'honoree'}
            id='sendTo-honoree'
            name='sendTo'
            onChange={() => store.iho.handleSendToChange('honoree')}
            type='radio'
            value='honoree'
          />
          <label htmlFor='sendTo-honoree'>
            {t(`views.donate_form.iho.${type}.delivery.action`)} to{' '}
            {store.iho.sendToHonoreeLabel}
          </label>
        </div>
        <div className='custom-check flex-shrink-0'>
          <input
            checked={sendTo === 'recipient'}
            id='sendTo-recipient'
            name='sendTo'
            onChange={() => store.iho.handleSendToChange('recipient')}
            type='radio'
            value='recipient'
          />
          <label htmlFor='sendTo-recipient'>
            {t(`views.donate_form.iho.${type}.delivery.action`)} to someone else
          </label>
        </div>
      </div>

      {sendTo === 'honoree' && type === 'email' && (
        <div className='input-wrapper lh honoree-delivery'>
          <div className='input-field-container'>
            <span className='preinput'>
              <i className='cw-icon-mail' />
            </span>
            <input
              data-parsley-errors-container='.iho-email-errors'
              name='recipientEmail'
              onChange={store.iho.updateHonoreeDraft}
              placeholder={t(
                'views.donate_form.iho.delivery.honoree_email_placeholder'
              )}
              required={true}
              type='email'
              value={recipientEmail}
            />
          </div>
          <div className='iho-email-errors' />
        </div>
      )}
      {sendTo === 'recipient' && (
        <div className='recipient-delivery'>
          <div className='input-wrapper'>
            <input
              name='recipientFullName'
              onChange={store.iho.updateHonoreeDraft}
              placeholder="Recipient's full name"
              required={true}
              type='text'
              value={recipientFullName}
              {...(store.iho.honoreeDraft.type === 'print' && {
                maxLength: '100',
              })}
            />
          </div>
          {type === 'email' && (
            <div className='input-wrapper'>
              <div className='input-field-container'>
                <span className='preinput'>
                  <i className='cw-icon-mail' />
                </span>
                <input
                  data-parsley-errors-container='.iho-email-errors'
                  name='recipientEmail'
                  onChange={store.iho.updateHonoreeDraft}
                  placeholder="Recipient's email"
                  required={true}
                  type='email'
                  value={recipientEmail}
                />
              </div>
              <div className='iho-email-errors' />
            </div>
          )}
        </div>
      )}
      {type === 'email' && (
        <>
          <div className='send-type'>
            <div className='input-wrapper'>
              <select
                name='sendType'
                onChange={store.iho.updateHonoreeDraft}
                value={sendType}
              >
                <option value='now'>Send now</option>
                <option value='schedule'>Schedule for...</option>
              </select>
            </div>
            {sendType === 'now' && (
              <p className='em'>
                We&#8217;ll send your card as soon as your donation has been
                processed.
              </p>
            )}
            {sendType === 'schedule' && (
              <div className='input-wrapper'>
                <input
                  defaultValue={sendOn}
                  name='sendOn'
                  readOnly={true}
                  ref={datepickerRef}
                  type='text'
                />
              </div>
            )}
          </div>
          <div className='custom-check'>
            <input
              checked={deliveryNotification}
              id='delivery-notification'
              name='deliveryNotification'
              onChange={store.iho.updateHonoreeDraft}
              type='checkbox'
            />
            <label htmlFor='delivery-notification'>Notify me when sent</label>
          </div>
        </>
      )}
    </>
  );
});

export default DonateFormIhoDelivery;
